module.exports = __webpack_public_path__ + "static/img/icon-entity.f9fdb1ad.svg";